import { ReactComponent as Logo } from "assets/images/v2/naf-hub-powered-by-logo.svg";
import "./sideBar.scss";

interface SideBarProps {
    children?: React.ReactNode;
}
const SideBar: React.FC<SideBarProps> = ({ children }) => {
    return (
        <div className="sidebar">
            <div className="sidebar-header label-large-bold sidebar-logo-hide-mobile">
                <Logo />
            </div>
            {children}
        </div>
    );
};
export default SideBar;